import {ChangeEventHandler, useContext} from "react";
import {FirebaseContext} from "../../firebase/FirebaseProvider";
import {FormControlLabel, Switch} from "@mui/material";

interface IVideoJob {
    config: any
    project: string
    resolution: string
}
export function VideoJob({config, project, resolution}: IVideoJob) {
    const components = resolution.split("_");
    const {set} = useContext(FirebaseContext);
    const handleChange:ChangeEventHandler<HTMLInputElement> = ({target}) => {
        set(`configs/${project}/video_jobs/${resolution}`, target.checked).catch(console.error)
    }

    if (! config || !config.video_jobs) return null;
    return <FormControlLabel control={<Switch checked={config.video_jobs[resolution]} onChange={handleChange}/>}
                             label={`${components[0].toUpperCase()} ${components[1]}`} sx={{margin: 1}}/>
}